import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

import { API_URL } from "../../helpers/app_url";
import axios from "axios"
import Moment from 'react-moment';
import ClientPageMenu from "./menu/all-client"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody
} from "reactstrap"
class RentalTimeline extends Component {
  constructor(props) {
    super(props)
    this.state = {
      leads:[]
    }
   
  }
  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer '+token;
   
    axios.get(API_URL + 'ClientEngagement/allbyagentrentalleaseexpiring',{ params: {
       agentId: parseInt(localStorage.getItem("userId")),
       cType:3,
       dType:2
    }, headers: { Authorization: str } })
      .then(res => {
        this.setState({ leads: res.data  });
      })
}
  realtorDate(isoDate) {
    let date = new Date(isoDate);
    let dtString = ''
    let monthString = ''
    if (date.getDate() < 10) {
      dtString = '0' + date.getDate();
    } else {
      dtString = String(date.getDate())
    }
    if (date.getMonth()+1 < 10) {
      monthString = '0' + Number(date.getMonth()+1);
    } else {
      monthString = String(date.getMonth()+1);
    }
    
    return monthString +'/' + date.getFullYear()
  }
  getBuyerType = (type) => {
    if (type == 1)
      return 'Rent';
    else if (type == 2)
      return 'Purchase';

  }

  getSellerType = (type) => {
    if (type == 1)
      return 'Sell';
    else if (type == 2)
      return 'Lease';

  }
  render() {
    const {isResponsive } = this.props;
    const { leads } = this.state;
    //
    const lanes = [];
    const cards = [];
    const Dates = []
    var dateObj = new Date();

    const brColor = [{borderBottom:'3px solid #0D6EFD'},{borderBottom:'3px solid #198754'},{borderBottom:'3px solid #0DCAF0'}, {borderBottom:'3px solid #AB2E3C'},{borderBottom:'3px solid #FFC107'}, {borderBottom:'3px solid #000'}];


      var dateStrings = [];
      var dateFormatOptions = {
        //day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      };
      var HeaddateFormatOptions = {
        month: 'long',
        year: 'numeric'
      };
      
      for (var i = 0; i < 6; ++i) {
    dateStrings.push(
      {
       "title": dateObj.toLocaleString('en-US', HeaddateFormatOptions),
        "leads": leads.filter(d => 
          d.endDate !== null && 
          dateObj.toLocaleString('en-US', dateFormatOptions) === this.realtorDate(d.endDate)
        )
      })
      dateObj.setMonth(dateObj.getMonth() + 1);
      }
  
    
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    
    return (
      <React.Fragment>
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Lead Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">
           
          {/* <Row className="project-header">
            <Col xl="7">
             <Breadcrumbs
              title={this.props.t("Client")}
              breadcrumbItem={this.props.t("Rental deals completing in next 6 months")}
            />
            </Col>
            <Col xl="5">
            
            </Col>
            </Row> */}
             <Card className="card-without-border">
              <CardHeader className="">
            <ClientPageMenu isResponsive={isResponsive} />
            </CardHeader>
            </Card>
            <Row>
                  <Col sm="12">
                   
                    <Card>
  <CardBody>
    {isResponsive ? (
     
      <Accordion open={this.state.openMonth} toggle={(id) => this.setState({ openMonth: this.state.openMonth === id ? null : id })}>
        {dateStrings.map((dateString, index) => (
          <AccordionItem key={dateString.title}>
            <AccordionHeader targetId={dateString.title} style={brColor[index]}>
              <div className="w-100">
                <span className="">{dateString.title}</span>
              </div>
            </AccordionHeader>
            <AccordionBody accordionId={dateString.title}>
              {dateString.leads.map((lead) => (
                <div className="mb-3 card custom-card" key={lead.id}>
                  <div className="card-body">
                    <div className="float-end ms-2">
                      <span className="badge rounded-pill badge-soft-success font-size-12">
                        {lead.id}-<Moment format="YYMM">{lead.startDate}</Moment>
                      </span>
                    </div>
                    <h5 className="card-title mb-2 lead-box-title">
                      <Link to={`/clients/activity/deal/${lead?.clientInfo?.id}/${lead?.clientInfo?.clientId}`}>
                        {lead.contactName}
                      </Link>
                    </h5>
                    <div>
                      {lead.isBuyer
                        ? `Buyer ${lead.buyerType ? `- ${this.getBuyerType(lead.buyerType)}` : ""}`
                        : lead.isSeller
                        ? `Seller ${lead.sellerType ? `- ${this.getSellerType(lead.sellerType)}` : ""}`
                        : ""}
                    </div>
                    <div><i className="bx bxs-calendar align-middle"></i>: {lead.endDate ? <Moment format="D MMM YY">{lead.endDate}</Moment> : ''}</div>
                  </div>
                </div>
              ))}
            </AccordionBody>
          </AccordionItem>
        ))}
      </Accordion>
    ) : (
      <>
        <Row className="toHeadingRow">
          {dateStrings.map((dateString, index) => (
            <Col sm="2" key={dateString.title}>
              <div className="topHeading" style={brColor[index]}>
                <span className="sc-kEqXSa CIzYb">{dateString.title}</span>
              </div>
            </Col>
          ))}
        </Row>

        <Row className="toRowContect">
          {dateStrings.map((dateString) => (
            <Col sm="2" key={dateString.title}>
              {dateString.leads.map((lead) => (
                <div className="container p-0" key={lead.id} style={{ marginTop: 10 }}>
                  <div className="mb-3 card custom-card">
                    <div className="card-body">
                      <div className="float-end ms-2">
                        <span className="badge rounded-pill badge-soft-success font-size-12">
                          {lead.id}-<Moment format="YYMM">{lead.startDate}</Moment>
                        </span>
                      </div>
                      <h5 className="card-title mb-2 lead-box-title">
                        <Link to={`/clients/activity/deal/${lead?.clientInfo?.id}/${lead?.clientInfo?.clientId}`}>{lead.contactName}</Link>
                      </h5>
                      <div>
                        {lead.isBuyer
                          ? `Buyer ${lead.buyerType ? `- ${this.getBuyerType(lead.buyerType)}` : ""}`
                          : lead.isSeller
                          ? `Seller ${lead.sellerType ? `- ${this.getSellerType(lead.sellerType)}` : ""}`
                          : ""}
                      </div>
                      <div><i className="bx bxs-calendar align-middle"></i>: {lead.endDate ? <Moment format="D MMM YY">{lead.endDate}</Moment> : ''}</div>
                    </div>
                  </div>
                </div>
              ))}
            </Col>
          ))}
        </Row>
      </>
    )}
  </CardBody>
</Card>

                  </Col>
                </Row>  
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
RentalTimeline.propTypes = {
  t: PropTypes.any,
  isResponsive:PropTypes.object
}
export default connect()(withTranslation()(RentalTimeline))
